import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { AbstractToggleFormComponent, EditablePanelComponent, LabelComponent } from '@spike/scaffolds';
import { AsyncApiService } from '@spike/core';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { PositionGeneralFormComponent } from "../../forms/position-general-form/position-general-form";
import { FormArray } from '@angular/forms';
import { PositionDocumentsFormComponent } from '../../forms/position-documents-form/position-documents-form';
import { Position } from '../../models/position.model';
import { PositionWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-general-toggle-panel',
  providers:[],
  imports: [EditablePanelComponent, PositionGeneralFormComponent, PositionDocumentsFormComponent, LabelComponent],
  templateUrl: './position-general-toggle-panel.html'
})
export class PositionGeneralTogglePanel extends AbstractToggleFormComponent<Position> {

  
  // Inject
  private readonly asyncApi = inject(AsyncApiService);
  private readonly formFactory = inject(FormFactoryService);

  // Input
  readonly data = input.required<Position>();
  
  // Output
  public readonly onSave = output<Position|undefined>();
  public readonly onPositionSelect = output<number>();

  // State
  public readonly form = this.formFactory.createPositionForm();
  public readonly documentsReady = signal<boolean>(false);

  get documentsArray(): FormArray { return this.form.get('documents') as FormArray;  }


  public override disabledFields = computed(()=>{
    const data = this.data();
    return PositionWorkflow.list!.find(x=>x.id == data?.stateId)?.disabledFields??[];
  })

  public readonly isReadOnly= computed(()=>{
    const data = this.data();
    return !!PositionWorkflow.list!.find(x=>x.id == data?.stateId)?.readonly;
  })

  async save() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const generalValues = this.form.getRawValue();
      const toSaveData: any = {
        ...generalValues,
        positionId: this.data()?.positionId,
        orderId: this.data()?.orderId,
      };
      const position = await this.asyncApi.save<Position>(EntityApiEnum.POSITION, toSaveData, this.data()?.positionId);
      this.onUpdate(position)
    }
  }

  public onUpdate(position?: Position){
    this.onSave.emit(position);
  }


  protected override buildFormArrays(data: Position): void {
    this.fillFormArray(this.documentsArray, data.documents,  (op) => this.formFactory.createDocumentForm(op));
    this.documentsReady.set(true);

  }

  deleteDocumentRow(index: number) {
    this.documentsArray.removeAt(index);
  }

  addDocumentRow() {
    this.documentsArray.push(this.formFactory.createDocumentForm());
  }


}